<template minapp='mpx' xlang='wxml'>
  <from-item isShow="{{isShow}}" 
    isRequired="{{isRequired}}" 
    isRequiredShow="{{isRequiredShow}}" 
    label="姓名" 
    innerValue="{{innerValue}}"
    nameTips="{{nameTips}}"
    isDisable="{{isNameDisable}}"
  >
    <input
      fixed
      wx:class="{{isFieldClass}}"
      wx:model="{{ innerValue }}"
      type="text"
      maxlength="{{52}}"
      placeholder="请填写真实姓名"
      bindblur="nameBoxBlur"
      slot="input"
    />
  </from-item>
</template>

<script>
import { watch } from "@mpxjs/core";

  import { createComponent } from '@didi/es-mpx-creator'
  import { checkName, hasRequired } from '@/utils'
  import Validator from '@/utils/validator'
  createComponent({
    classes: [],
    data: {
      innerValue:''
    },
    props: {
      value:{
        type: String,
        value: ''
      },
      isNameDisable:{
        type: Boolean,
        value: false
      },
      isRequiredShow: {
        type: Boolean,
        value: false
      },
      isShow: {
        type: Boolean,
        value: false
      },
      // hasRequired:{
      //   type: Boolean,
      //   value: false
      // },
      category:{
        type: String,
        value: 'common'
      },
      item:Object,
      selectedCardList:Array,
      isNeedCard:Boolean,
      showChangeBtn:Boolean,
      nameTips:""
    },
    computed: {
      isFieldClass(){
        let tempClass = ['es-content__input']
        if(this.showChangeBtn){
          tempClass.push('es-content__show-btn')
        }
        return tempClass
      },
      // nameTips() {
      //   var validator = new Validator()
      //   validator.cbAdd(this.innerValue, this.item.validator, this.item.tips)
      //   return validator.start()
      // },
      isRequired() {
        return hasRequired(this.item?.requiredcCrdTypes,this.selectedCardList,this.item?.isRequired,this.isNeedCard)
      }
    },
    methods: {
      nameBoxBlur(e){
        let value = e?.detail?.value || ''
        setTimeout(() => {
          this.innerValue = (value + '').toUpperCase()
        }, 100)
        var validator = new Validator()
        validator.cbAdd(this.innerValue, this.item.validator, this.item.tips)
        this.nameTips =  validator.start()
      }
    },
    watch:{
      value(val) {
        this.innerValue = val
      },
      //将数据回传
      innerValue(newValue) {
        this.$trigger( 'input', {value:newValue} )
      },
    },
    mounted() {
      this.innerValue = this.value
    }

  })
</script>

<style lang='stylus' scoped>
  +b('content')
    +e('input')
      box-sizing border-box
      width calc(100% - 6px)
      height 24px
      resize none
      background-color transparent
      text-align left
      line-height 24px
      -webkit-appearance none //是为了去除内阴影样式，但是缺点是不可输入；
      -webkit-user-select auto// 解决输入问题
    +e('show-btn')
      width calc(100% - 82px)
      
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-cell': '@didi/es-mpx-ui/lib/cell',
      'es-field': '@didi/es-mpx-ui/lib/field',
      'from-item': './from-item'
    }
  }
</script>

